import React from "react";
import { useDispatch } from "react-redux";
import { showCallbackForm } from "@app/store/layoutSlice";
import SupportIcon from "@shared/ui/Icon/ui/SupportIcon/SupportIcon";
import classes from "./callback-form-button.module.scss";
import CBIconClasses from "@shared/ui/Icon/ui/SupportIcon/SupportIcon.module.scss";

const CallbackFormButton: React.FC = () => {
    const [isHovered, setIsHovered] = React.useState(false);
    const dispatch = useDispatch();
    const openForm = () => {
        dispatch(showCallbackForm());
    };
    return (
        <div
            onClick={openForm}
            className={classes.CBButton}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <SupportIcon className={isHovered ? CBIconClasses.Hovered : ""} />
        </div>
    );
};

export default CallbackFormButton;